import { useSearchParams, useLocation, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { BANK_TRANSFER_INFO } from '@/lib/bankInfo';

type OrderCompleteState = {
  email?: string;
  shippingFee?: number;
  methodLabel?: string;
  paymentMethod?: 'card' | 'bank_transfer';
  total?: number;
};

export default function OrderCompletePage() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');
  const location = useLocation();
  const state = (location.state as OrderCompleteState | null) ?? {};

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center justify-center px-6 py-20">
        <div className="text-center max-w-xl">
          <div className="w-20 h-20 flex items-center justify-center mx-auto mb-8 bg-primary-100 rounded-full">
            <i className="ri-check-line text-3xl text-primary-600"></i>
          </div>
          <h1 className="text-4xl md:text-5xl font-light text-foreground-950 mb-4"
            style={{ fontFamily: "var(--font-heading)" }}>
            Thank You!
          </h1>
          {orderId && (
            <p className="text-sm text-foreground-500 mb-6 tracking-wider"
              style={{ fontFamily: "var(--font-heading)" }}>
              Order #{orderId}
            </p>
          )}

          {state.email && (
            <div className="inline-flex items-center gap-2 bg-background-100 border border-background-200 rounded-full px-5 py-2 mb-4">
              <div className="w-5 h-5 flex items-center justify-center text-foreground-500">
                <i className="ri-mail-line"></i>
              </div>
              <span className="text-sm text-foreground-700"
                style={{ fontFamily: "var(--font-body)" }}>
                {state.email}
              </span>
            </div>
          )}

          {state.methodLabel && (
            <div className="inline-flex items-center gap-2 bg-secondary-100 rounded-full px-5 py-2 mb-6">
              <div className="w-5 h-5 flex items-center justify-center text-secondary-600">
                <i className="ri-truck-line"></i>
              </div>
              <span className="text-sm text-secondary-800 tracking-wider"
                style={{ fontFamily: "var(--font-heading)" }}>
                {state.methodLabel}
              </span>
              {typeof state.shippingFee === 'number' && (
                <span className="text-sm text-secondary-600"
                  style={{ fontFamily: "var(--font-body)" }}>
                  ¥{state.shippingFee.toLocaleString()}
                </span>
              )}
            </div>
          )}

          {state.paymentMethod === 'bank_transfer' ? (
            <div className="bg-secondary-50 border border-secondary-200 rounded-xl p-6 mb-10 text-left">
              <p className="text-sm text-foreground-900 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
                下記口座へお振込みください
              </p>
              <div className="text-sm text-foreground-700 space-y-1 mb-4">
                <p>{BANK_TRANSFER_INFO.bankName} {BANK_TRANSFER_INFO.branchName}</p>
                <p>{BANK_TRANSFER_INFO.accountType} {BANK_TRANSFER_INFO.accountNumber}</p>
                <p>{BANK_TRANSFER_INFO.accountHolder}</p>
              </div>
              {typeof state.total === 'number' && (
                <p className="text-base text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
                  お振込み金額: ¥{state.total.toLocaleString()}
                </p>
              )}
              <p className="text-xs text-foreground-500 leading-relaxed">
                恐れ入りますが、振込手数料はお客様のご負担でお願いいたします。入金確認後7日以内に発送いたします。
              </p>
            </div>
          ) : (
            <p className="text-base text-foreground-600 leading-relaxed mb-10"
              style={{ fontFamily: "var(--font-body)" }}>
              ご注文を受け付けました。<br />
              確認メールをお送りしますので、しばらくお待ちください。
            </p>
          )}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-primary-500 text-white px-10 py-4 text-sm tracking-[0.15em] hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer rounded-full"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              Back to Top
            </Link>
            <Link
              to="/products"
              className="inline-flex items-center justify-center gap-2 border border-foreground-300 text-foreground-700 px-10 py-4 text-sm tracking-[0.15em] hover:border-primary-400 transition-colors whitespace-nowrap cursor-pointer rounded-full"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              Continue Shopping
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
